(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_nts-low-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nts-low-stock')) {
    class NTSLowStock extends HTMLElement {
      connectedCallback() {
        this.listeners?.abort();
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.form = document.getElementById(this.dataset.form);
        this.variantId = this.dataset.variant;
        this.form?.addEventListener('variant:change', (event) => {
          this.variantId = String(event.detail?.variant?.id || '');
          this.hidden = true;
          this.refresh();
        }, options);
        document.addEventListener('cart:change', () => this.refresh(), options);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.refresh();
        }, options);
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.refresh();
        }, options);
        clearInterval(this.timer);
        this.timer = setInterval(() => this.refresh(), 60000);
      }

      disconnectedCallback() {
        this.listeners?.abort();
        this.request?.abort();
        clearInterval(this.timer);
      }

      async refresh() {
        this.request?.abort();
        if (!this.variantId) {
          this.hidden = true;
          return;
        }
        if (document.hidden || !this.isConnected) return;
        const request = new AbortController();
        this.request = request;
        const variantId = this.variantId;
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.set('variant', variantId);
        const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewId) url.searchParams.set('preview_theme_id', previewId);
        try {
          const response = await fetch(url, { signal: request.signal, cache: 'no-store' });
          if (!response.ok) throw new Error('Stock refresh failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = html.getElementById(this.id);
          if (!next || next.dataset.variant !== variantId) throw new Error('Stock variant unavailable');
          if (this.variantId !== variantId || request.signal.aborted) return;
          this.querySelector('[data-nts-stock-message]').textContent = next.querySelector('[data-nts-stock-message]').textContent;
          this.dataset.urgent = next.dataset.urgent;
          this.hidden = next.hidden;
        } catch (error) {
          if (error.name !== 'AbortError' && this.variantId === variantId) this.hidden = true;
        }
      }
    }
    customElements.define('nts-low-stock', NTSLowStock);
  }
  } catch(e) { console.error(e); }
})();

})();
